import { api } from "../utils/api";
import type {
  RestCreateModifierGroup,
  RestModifierGroup,
  RestUpdateModifierGroup,
} from "@KassaroAB/shared/types/modifierGroup";
import type { ModifierGroupId } from "@KassaroAB/shared/types/ids";
import {
  catalogCollectionPath,
  type CatalogScope,
} from "./catalogScope";

const modifierGroupsPath = (scope: CatalogScope) =>
  catalogCollectionPath(scope, "modifierGroups");

export const getModifierGroupsApi = (
  scope: CatalogScope,
): Promise<RestModifierGroup[]> => {
  return api.get(modifierGroupsPath(scope));
};

export const getModifierGroupApi = (
  scope: CatalogScope,
  modifierGroupId: ModifierGroupId,
): Promise<RestModifierGroup> => {
  return api.get(`${modifierGroupsPath(scope)}/${modifierGroupId}`);
};

export const createModifierGroupApi = (
  scope: CatalogScope,
  group: RestCreateModifierGroup,
): Promise<RestModifierGroup> => {
  return api.post(modifierGroupsPath(scope), group);
};

export const updateModifierGroupApi = (
  scope: CatalogScope,
  modifierGroupId: ModifierGroupId,
  group: RestUpdateModifierGroup,
): Promise<RestModifierGroup> => {
  return api.put(`${modifierGroupsPath(scope)}/${modifierGroupId}`, group);
};

export const deleteModifierGroupApi = (
  scope: CatalogScope,
  modifierGroupId: ModifierGroupId,
): Promise<void> => {
  return api.delete(`${modifierGroupsPath(scope)}/${modifierGroupId}`);
};
